import translations from '../files/es.json';
export const locale = {
  lang: 'es',
  data: Object.assign({}, translations),
};

